import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { DEFAULT_LOCALE, LANGUAGES } from "./languages"

import enHome from "./locales/en/home.json"
import enCommon from "./locales/en/common.json"
import enModal from "./locales/en/modal.json"
import enAuHome from "./locales/en_AU/home.json"
import enAuCommon from "./locales/en_AU/common.json"
import enAuModal from "./locales/en_AU/modal.json"
import enCaHome from "./locales/en_CA/home.json"
import enCaCommon from "./locales/en_CA/common.json"
import enCaModal from "./locales/en_CA/modal.json"
import enJpHome from "./locales/en_JP/home.json"
import enJpCommon from "./locales/en_JP/common.json"
import enJpModal from "./locales/en_JP/modal.json"
import frHome from "./locales/fr/home.json"
import frCommon from "./locales/fr/common.json"
import frModal from "./locales/fr/modal.json"
import deHome from "./locales/de/home.json"
import deCommon from "./locales/de/common.json"
import deModal from "./locales/de/modal.json"
import itHome from "./locales/it/home.json"
import itCommon from "./locales/it/common.json"
import itModal from "./locales/it/modal.json"
import esHome from "./locales/es/home.json"
import esCommon from "./locales/es/common.json"
import esModal from "./locales/es/modal.json"
import jaJpHome from "./locales/ja_JP/home.json"
import jaJpCommon from "./locales/ja_JP/common.json"
import jaJpModal from "./locales/ja_JP/modal.json"
import zhHansHkHome from "./locales/zh_Hans_HK/home.json"
import zhHansHkCommon from "./locales/zh_Hans_HK/common.json"
import zhHansHkModal from "./locales/zh_Hans_HK/modal.json"
import zhHkHome from "./locales/zh_HK/home.json"
import zhHkCommon from "./locales/zh_HK/common.json"
import zhHkModal from "./locales/zh_HK/modal.json"

const resources = {
	en:         { home: enHome,        common: enCommon,        modal: enModal },
	en_AU:      { home: enAuHome,      common: enAuCommon,      modal: enAuModal },
	en_CA:      { home: enCaHome,      common: enCaCommon,      modal: enCaModal },
	en_JP:      { home: enJpHome,      common: enJpCommon,      modal: enJpModal },
	fr:         { home: frHome,        common: frCommon,        modal: frModal },
	de:         { home: deHome,        common: deCommon,        modal: deModal },
	it:         { home: itHome,        common: itCommon,        modal: itModal },
	es:         { home: esHome,        common: esCommon,        modal: esModal },
	ja_JP:      { home: jaJpHome,      common: jaJpCommon,      modal: jaJpModal },
	zh_Hans_HK: { home: zhHansHkHome,  common: zhHansHkCommon,  modal: zhHansHkModal },
	zh_HK:      { home: zhHkHome,      common: zhHkCommon,      modal: zhHkModal },
}

const RESERVED_OPTION_KEYS = new Set([
	"defaultValue",
	"lng",
	"ns",
	"keySeparator",
	"nsSeparator",
	"interpolation",
	"replace",
	"postProcess",
	"joinArrays",
	"returnObjects",
	"returnDetails",
	"context",
	"lngs",
])

const sprintfPostProcessor = {
	type: "postProcessor",
	name: "sprintf",
	process(value, _key, options) {
		if (typeof value !== "string" || value.indexOf("%") === -1) return value
		const positional = Object.entries(options || {})
			.filter(([k]) => !RESERVED_OPTION_KEYS.has(k))
			.map(([, v]) => v)
		return value.replace(/%(\d+)\$s/g, (match, num) => {
			const idx = parseInt(num, 10) - 1
			return positional[idx] !== undefined ? String(positional[idx]) : match
		})
	},
}

if (!i18n.isInitialized) {
	i18n.use(initReactI18next).use(sprintfPostProcessor).init({
		resources,
		lng: DEFAULT_LOCALE,
		fallbackLng: DEFAULT_LOCALE,
		supportedLngs: LANGUAGES.map((l) => l.code),
		defaultNS: "home",
		ns: ["home", "common", "modal"],
		interpolation: { escapeValue: false },
		postProcess: ["sprintf"],
		react: { useSuspense: false },
	})
}

export default i18n
